
<template>


    <v-layout >
        <v-content>
            <v-container text-lg-right fill-height>
                <v-layout row wrap align-top>

                    <v-flex  xs10 offset-xs1 class="rtl text-xs-center">
                        <div class="display-2 text-xs-center">Mendy</div>
                        <div class="headline text-xs-center">נא להשאיר טאב זה פתוח בדפדפן תמיד</div>
                        <br>
                        <hr>
                        <div style="padding: 6px;" class="title text-xs-center">
                            עודכן לאחרונה ב-{{updatedDate.format('DD/MM/YYYY HH:mm:ss')}} - {{updatedFromNew}}
                        </div>
                        <v-alert
                                v-model="alert"
                                dismissible
                                type="error"
                        >
                            הייתה  תקלה בהעלאת הקובץ לשרת.
                        </v-alert>
                        <hr>
                        <br>
                        <input type="file" @change="previewFiles($event)"/>
                    </v-flex>

                </v-layout>
            </v-container>
        </v-content>
    </v-layout>
</template>

<script>

    import axios from 'axios';

    const moment = require('moment-timezone');
    moment.fn.fromNowOrNow = function (a) {
        if (Math.abs(moment().diff(this)) < 10 * 1000) { // 1000 milliseconds
            return 'הרגע בערך';
        }
        if (Math.abs(moment().diff(this)) < 25 * 1000) { // 1000 milliseconds
            return 'לפני פחות מחצי דקה';
        }
        if (Math.abs(moment().diff(this)) < 40 * 1000) { // 1000 milliseconds
            return 'לפני חצי דקה כזה';
        }
        if (Math.abs(moment().diff(this)) < 55 * 1000) { // 1000 milliseconds
            return 'לפני כמעט דקה';
        }
        if (Math.abs(moment().diff(this)) < 75 * 1000) { // 1000 milliseconds
            return 'לפני דקה';
        }
        if (Math.abs(moment().diff(this)) < 105 * 1000) { // 1000 milliseconds
            return 'לפני דקה וחצי בערך';
        }
        return this.fromNow(a);
    }

    export default {
        name: "Upload",
        data: () => ({
            updatedDate : moment().tz("Asia/Jerusalem"),
            updatedFromNew : 'טרם',
            alert : false
        }),
        // props: ['loading', 'showSnackbar', 'snackbarText'],
        created() {
            this.$socket.on('*', (packet) => {
                // log(packet)
                let channel = packet.data[0];
                let data = packet.data[1];
                let $uniqid = data.$uniqid;
                if($uniqid) {
                    return this.$socket.res(data);
                }
                this.sockets(channel, data);
            });

            // console.log('this.$user', this.$user)
            this.$emit('update:loading', false);

            setInterval(()=>{

                this.updatedFromNew = '(' + moment(this.updatedDate).locale('he').tz("Asia/Jerusalem").fromNowOrNow() + ')';
                // log(this.updatedDate.format('DD/MM/YYYY HH:mm:ss'), this.updatedFromNew);
            }, 1000);

            /*setInterval(()=>{
                this.$socket.req('sum.channel', {sum : 'data 123'}).then(data => {
                    log('res *Upload* sun.channel data <=', data);
                });
            }, 2000)*/

        },
        beforeRouteLeave(to, from, next) {
            this.$socket.off('*');
            this.$emit('update:loading', true);
            // next();
            location.href = location.origin + '/app' + to.fullPath
            // location.href = location.href;
        },

        methods : {
            sockets : function (channel, data) {
                let channels = {
                  'sum.channel' : (/*data*/) => {
                        console.log('sum.channel', data, this.aaabbb)
                    }
                };
                if(!channels[channel]) {
                    return console.log('Socket channel not found:', channel);
                }

                return channels[channel](data);
            },

            previewFiles : function (e) {
                let $this = this;
                let files = e.target.files || e.dataTransfer.files;
                $this.uploadFile(files);


                let diff2midnight = (24 - moment().tz("Asia/Jerusalem").format('HH') + 2); // hours diff now to 02:00

                setTimeout(() => {
                    $this.uploadFile(files);

                    setInterval(() => {
                        // window.requestFileSystem(window.TEMPORARY, 1024*1024, function(fs) {

                        $this.uploadFile(files);
                        // }, errorHandler);
                    }, 1000 * 60 * 60 * 24);
                }, diff2midnight * 1000 * 60 * 60);


                function errorHandler(e) {
                    console.error(e)
                }
            },

            uploadFile(files) {
                console.log('Mendi upload');

                let $this = this;

                $this.alert = false;
                $this.$emit('update:loading', true);
                let formData = new FormData();
                formData.append('file', files[0]);
                axios.post(this.$server_api_url + `/api/v1/mendi/upload`,
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                ).then(function(){
                    $this.updatedDate =  moment().tz("Asia/Jerusalem");
                    $this.$emit('update:snackbar', {
                        text : 'הקובץ עודכן בהצלחה',
                        show : true
                    });
                })
                    .catch(function(){
                        $this.$emit('update:snackbar', {
                            text : 'תקלה - הקובץ לא עלה לשרת',
                            show : true
                        });
                        //console.log('תקלה - הקובץ לא עלה לשרת', $this.updatedDate.format('DD/MM/YYYY HH:mm:ss'));
                        $this.alert = true;
                    }).finally(() => {
                    $this.$emit('update:loading', false);
                });

            }
        }
    }
</script>

<style scoped>

</style>